import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import { CFormText, CInputGroup, CFormInput, CButton } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilSearch } from '@coreui/icons'
import { useDispatch, useSelector } from 'react-redux'

const Buscar = (props) => {
  const { tipo } = props
  const history = useHistory()
  const [buscar, setBuscar] = useState('')
  const basePath = String(process.env.PUBLIC_URL).trim()
  const storeData = useSelector((state) => state)
  const dispatch = useDispatch()

  const validando = () => {
    return buscar.trim().length > 2 && buscar.length < 51
  }

  const buscador_ir = () => {
    let pathname = storeData.lastPathname || 'tramites'
    var ele = document.getElementById('validationBuscador')
    ele.setAttribute('class', 'form-control')

    if (validando()) {
      dispatch({
        type: 'set',
        ultimaPagBuscador: 1,
        filtros: null,
      })

      history.push({
        pathname: basePath + '/ps/buscador/' + pathname,
        search: 'd=' + encodeURI(buscar.trim()),
      })

      window.location.reload()
    } else {
      var ele = document.getElementById('validationBuscador')
      if (tipo === 'home') {
        /*ele.setAttribute(
          'class',
          'form-control buscador-home-celular buscador-home-celular-invalid is-invalid',
        )*/
        ele.setAttribute('class', 'form-control is-invalid')
      } else {
        ele.setAttribute('class', 'form-control is-invalid')
      }
      document.getElementById('validationMensaje').setAttribute('class', 'invalid-feedback')
    }
  }

  function handleKeyPress(e) {
    var ele = document.getElementById('validationBuscador')
    if (tipo === 'home') {
      //ele.setAttribute('class', 'form-control buscador-home-celular')
      ele.setAttribute('class', 'form-control')
    } else {
      ele.setAttribute('class', 'form-control')
    }
    if (e.key === 'Enter') {
      buscador_ir()
    }
  }

  return (
    <CInputGroup
      className={tipo === 'home' ? 'mt-100 mb-100 has-validation' : 'md-3 mt-75 has-validation'}
    >
      <CFormInput
        maxLength="50"
        placeholder="Buscar Trámites, Servicios y Áreas ..."
        aria-label="Buscar"
        //className={tipo === 'home' ? 'form-control buscador-home-celular' : 'form-control'}
        className={'form-control'}
        value={buscar}
        id="validationBuscador"
        onChange={(e) => {
          setBuscar(e.target.value.replace(/[&\\#,+()$~%.'":*?<>{}]/g, ''))
        }}
        onKeyPress={handleKeyPress}
      />
      <CButton
        //className={tipo === 'home' ? 'buscador-home-celular-btn' : ''}
        //color={tipo === 'home' ? 'dark' : 'secondary'}
        //variant={tipo === 'home' ? 'ghost' : ''}
        className={''}
        color={'secondary'}
        variant={''}
        aria-label="Buscar"
        onClick={() => {
          buscador_ir()
        }}
      >
        <CIcon icon={cilSearch} size={'sm'} />
      </CButton>
      <CFormText
        className="d-none invalid-feedback"
        id="validationMensaje"
        style={{
          fontSize: '0.8rem',
          paddingLeft: '0.5rem',
          fontWeight: '200',
        }}
      >
        Ingrese al menos tres caracteres.
      </CFormText>
    </CInputGroup>
  )
}

Buscar.propTypes = {
  tipo: PropTypes.string,
}

export default Buscar
